<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-etghtft-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-etghtft-' + id"
    :aria-controls="'collapse-etghtft-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_ETGHTFT") }}
  .collapse.show(
    :aria-labelledby="'heading-etghtft-' + id"
    :id="'collapse-etghtft-' + id"
  )
    .card-body.p-0
      //- small.text-dark {{ Object.keys(moreItems['etghtfto']) }}
      //- small.text-danger {{ scores.running }}
      .market-card-content
        .three-column
          .three-column-title
            .market-card-filter
              .score-dropdown-wrapper
                .score-dropdown
                  button#score-dropdown-btn.dropdown-btn(type='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
                    | HT {{ ht }}
                  .dropdown-menu(aria-labelledby='score-dropdown-btn')
                    a.dropdown-item(@click="selectHalfTime(item)" v-for="(item, index) in htKeys") {{ item }}
                .score-dropdown
                  button#score-dropdown-btn.dropdown-btn(type='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
                    | FT {{ ETGHTFTX[ft] }}
                  .dropdown-menu(v-if="moreItems['etghtfto'][ht] && moreItems['etghtfto'][ht][78] && moreItems['etghtfto'][ht][78].length > 0" aria-labelledby='score-dropdown-btn')
                    template(v-if="ht")
                      a.dropdown-item(@click="selectFullTime(item)" v-for="(item, index) in moreItems['etghtfto'][ht][78]") {{ ETGHTFTX[item] }}
                oddsColumnItem(:odds="moreItems['etghtfto'][ht]" :idx="ft" :typ="oddsType")
              .view-all-btn.collapsed(data-toggle='collapse' href='#etg-htft' role='button' aria-expanded='false' aria-controls='etg-htft') {{ $t("ui.all") }}
          #etg-htft.correct-score-three-column.collapse
            .three-column-group
              template(v-for="(i,n) in ftKeys")
                template(v-if="!scores.running.includes(i)")
                  .three-column-odd-area(v-for="j in moreItems['etghtfto'][i][78]")
                    .three-column-odd-area-oddtype
                      p.mb-0 {{ i }} /  {{ ETGHTFTX[j] }}
                    .three-column-odd-area-group
                      .odd-box
                        .odd
                          oddsColumnItem.odd-value(:odds="moreItems['etghtfto'][i]" :idx="j" :typ="oddsType")
</template>

<script>
import config from "@/config";
import oddsColumnItem from "@/components/mobile/main/xitem/oddsColumnItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    oddsColumnItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      view_all: false,
      ht: null,
      ft: null,
    }
  },
  computed: {
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    },
    htKeys() {
      var A = this.scores.running;
      if (!this.moreItems || !this.moreItems["etghtfto"]) {
        return [];
      }
      var B = Object.keys(this.moreItems["etghtfto"]);

      const ASet = new Set(A);
      const result = [];
      for (let i = 0; i < B.length; i++) {
        if (!ASet.has(B[i])) {
          result.push(B[i]);
        }
      }

      return result;
    },
    ftKeys() {
      if (!this.moreItems || !this.moreItems["etghtfto"]) {
        return [];
      }
      return Object.keys(this.moreItems["etghtfto"]);
    },
    ETGHTFTX() {
      return config.ETGHTFTX;
    },
    match() {
      return this.$store.getters.data.match[this.matchId];
    },
    scores() {
      var home_score = -1;
      var away_score = -1;
      if (!this.match) {
        return {
          home_score,
          away_score,
          total_goal: -1,
          running: []
        };
      }
      var score = this.match[11];

      if (score && score.trim() !== "") {
        var result = score.split(" - ");
        if (result.length === 2) {
          home_score = isNaN(parseInt(result[0].trim(), 10)) ? -1 : parseInt(result[0].trim(), 10);
          away_score = isNaN(parseInt(result[1].trim(), 10)) ? -1 : parseInt(result[1].trim(), 10);
        }
      }

      var total_goal = home_score + away_score;
      var running = [];

      // Generate half-time scores that should be excluded (less than total_goal)
      if (total_goal <= 7) {
        for (var ht = 0; ht < total_goal; ht++) {
          running.push(ht.toString());
        }
      } else {
        // For total_goal > 7, exclude 0-6 only, "7+" should be available
        for (var ht = 0; ht < 7; ht++) {
          running.push(ht.toString());
        }
      }

      return {
        home_score,
        away_score,
        total_goal,
        running,
      };
    },
  },
  mounted() {
    if (!this.moreItems || !this.moreItems["etghtfto"]) {
      return;
    }
    // Set initial ht and ft based on total_goal
    var total_goal = this.scores.total_goal;
    var initial_ht = total_goal >= 0 ? (total_goal >= 7 ? "7+" : total_goal.toString()) : "0";

    // Check if the calculated ht exists in htKeys, otherwise use first available
    if (this.htKeys.includes(initial_ht)) {
      this.selectHalfTime(initial_ht);
    } else if (this.htKeys.length > 0) {
      this.selectHalfTime(this.htKeys[0]);
    }
  },
  methods: {
    toggleViewAll() {
      this.view_all = !this.view_all;
    },
    selectHalfTime(e) {
      if (!this.moreItems || !this.moreItems["etghtfto"] || !this.moreItems["etghtfto"][e]) {
        return;
      }
      var ftOptions = this.moreItems["etghtfto"][e][78];
      if (!ftOptions || !ftOptions.length) {
        return;
      }
      this.ht = e;
      this.ft = ftOptions[0];
    },
    selectFullTime(e) {
      this.ft = e;
    },
  },
}
</script>